<template>
  <div>
    <div>
      <v-btn class="primary" @click="close_card_dialog()">
        <v-icon>mdi-close</v-icon> Закрыть
      </v-btn>
    </div>

    <v-card v-if="(GETTERS_USER_ALL !== null) && (GETTERS_USER_ALL !== undefined)" class="main-card">

      <v-card-title text-color="#15336d">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-skeleton-loader
                :loading="loading"
                height="94"
                type="list-item-two-line">
                <v-list-item-title
                  class="title"> ID {{GETTERS_USER_ALL.id}} : {{GETTERS_USER_ALL.individual.last_name}} {{GETTERS_USER_ALL.individual.first_name}} {{GETTERS_USER_ALL.individual.second_name}}
                </v-list-item-title>
                <v-list-item-subtitle>{{GETTERS_USER_ALL.user.email}}</v-list-item-subtitle>

                <!-- <template>
                  <v-chip
                    v-for="(item, index) in roles"
                    :key="index"
                    class=""
                    x-small>
                    {{item.name}}
                  </v-chip>
                </template> -->
              </v-skeleton-loader>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="4">
              <v-skeleton-loader
                :loading="loading"
                height="94"
                type="list-item-two-line">
              <v-text-field
              v-model="current_last_name"
              :label="surNameLabel"
              required></v-text-field>
              </v-skeleton-loader>
            </v-col>
            <v-col cols="12" md="4">
              <v-skeleton-loader
                :loading="loading"
                height="94"
                type="list-item-two-line">
                <v-text-field
                  v-model="current_first_name"
                  :label="nameLabel"
                  required>
                </v-text-field>
              </v-skeleton-loader>
            </v-col>
            <v-col cols="12" md="4">
              <v-skeleton-loader
                :loading="loading"
                height="94"
                type="list-item-two-line">
              <v-text-field
                  v-model="current_middle_name"
                  :label="patronymicLabel" required>
               </v-text-field>
              </v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols='12'>
              <v-skeleton-loader
                :loading="loading"
                height="94"
                type="list-item-two-line">
              <v-autocomplete
                v-model="current_organization_id"
                :items="GETTERS_ALL_ORGANIZATIONS"
                item-text="name"
                item-value="id"
                :label="scienceOrganizationLabel"
                prepend-icon="mdi-city"
              ></v-autocomplete>
              </v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row style="margin-top: -20px">
            <v-col class="pt-3" cols="12" lg="4">
              <v-checkbox
                class="mt-0"
                :color="$mainColor"
                v-model="checkbox_other_org"
                label="другая"
              ></v-checkbox>
            </v-col>
            <v-col class="pt-0" cols="12" lg="8">
              <v-text-field
                class="mt-0"
                v-if="checkbox_other_org"
                v-model="current_other_org_descr"
                placeholder="название организации"
                label="название организации"
              ></v-text-field>
            </v-col>
          </v-row>

        </v-card-text>
        <v-card-actions>
          <v-btn
            color="#16336e"
            dark
            outlined
            label
            class="mr-4 ml-2"
            :loading="loaded"
            @click="save_btn"
          >Сохранить</v-btn>
        </v-card-actions>

      </v-card>
  </div>
</template>
<script>

import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: 'userCard',
  components: {
  },
  props: {
  },

  data() {
    return {
      loading: false,
      loaded: false,


      current_last_name: null,
      current_first_name: null,
      current_middle_name: null,
      current_organization_id: null,
      current_other_org_descr: '',
      checkbox_other_org: false,
    };
  },

  beforeMount() {
    if(!this.GETTERS_ALL_ORGANIZATIONS.length)
      this.LOAD_ALL_ORGANIZATIONS('ru')
  },

  mounted() {
    this.prepare_data_user();
  },

  computed: {
    ...mapGetters([
      'GETTERS_USER_ALL',
      'GETTERS_ALL_ORGANIZATIONS',
    ]),

    surNameLabel() {
      return 'Фамилия';
    },
    scienceOrganizationLabel() {
      return 'Научная организация';
    },
    nameLabel() {
      return 'Имя';
    },
    patronymicLabel() {
      return 'Отчество';
    },
  },

  methods:  {
    ...mapActions([
      'LOAD_ALL_ORGANIZATIONS',
      'UPDATE_PROFILE_DETAIL',
    ]),
    ...mapMutations([
    ]),

    prepare_data_user(){
      this.current_last_name = this.GETTERS_USER_ALL.individual.last_name;
      this.current_first_name = this.GETTERS_USER_ALL.individual.first_name;
      this.current_middle_name = this.GETTERS_USER_ALL.individual.middle_name;
      this.current_organization_id = this.GETTERS_USER_ALL.individual.organization_id;
      this.current_other_org_descr = this.GETTERS_USER_ALL.individual.other_org_descr;

    },

    get_params() {
      var r = {
        id: this.GETTERS_USER_ALL.id,
        first_name: this.current_first_name,
        last_name: this.current_last_name,
        middle_name: this.current_middle_name,
        organization_id: this.current_organization_id,
        other_org_descr: ''
      }

      if(this.checkbox_other_org)
        r['other_org_descr'] = this.current_other_org_descr

      return r
    },

    save_btn() {
      this.boilerplate = true;
      this.loaded = true;

      this.UPDATE_PROFILE_DETAIL(this.get_params())
        .then((res) => {
          if (res.status === 200) this.$messageHelper('Данные сохранены', 'success', 3000);
          this.loaded = false;
          this.need_update_profile = false;
          this.$emit('reloadParent')
        })
        .catch((e) => {
          this.dialog = true;
          this.loaded = false;
          this.head_info = 'Ошибка';
          this.info = `${e}`;
          this.$messageHelper(`${e}`, 'error', 3000);
        });
    },

    close_card_dialog(){
      this.proposals_id_stack = [];
      this.$emit('closeUserDialog');
    },
  },

  watch:{
    GETTERS_USER_ALL(val){
      this.prepare_data_user()
    },

    checkbox_other_org(val){
      if(val){
        this.current_organization_id = 134
      }
      else
        if(this.current_organization_id == 134)
          this.current_organization_id = ''
        // this.current_organization_id = this.GETTERS_USER_ALL.individual.organization_id
    },

    current_organization_id(val){
      if(val == '134')
        this.checkbox_other_org = true
      else
        this.checkbox_other_org = false
    },
  },

  filters: {
  },
};
</script>

